// デッキのフォーマット定義。
// カードデータ（shared/data/*.json）を import しない軽量モジュールにしておくことで、
// Worker がフォーマット定義を参照しても大量の card JSON をバンドルせずに済む。

export type DeckFormat = "05" | "08" | "DMR14" | "DMR15";

export const DECK_FORMATS: DeckFormat[] = ["05", "08", "DMR14", "DMR15"];

export const DEFAULT_FORMAT: DeckFormat = "DMR15";

// 各フォーマットで使用可能な「最終弾」（この弾までのカードが使える）。値は弾コード。
export const FORMAT_CUTOFF: Record<DeckFormat, string> = {
  "05": "dm-16",
  "08": "dm-30",
  DMR14: "dmr-14",
  // 時系列上の最終弾（dmr-15 直後の DMX-19 = 2015-01-24）まで含める。
  DMR15: "dmx-19",
};

// 一覧やセレクタでの表示名。
export const FORMAT_LABELS: Record<DeckFormat, string> = {
  "05": "05（〜DM-16）",
  "08": "08（〜DM-30）",
  DMR14: "DMR14（〜DMR-14）",
  DMR15: "DMR15（〜DMX-19）",
};

export function isDeckFormat(value: unknown): value is DeckFormat {
  return typeof value === "string" && (DECK_FORMATS as string[]).includes(value);
}
